import { render, staticRenderFns } from "./PoList.vue?vue&type=template&id=f54ac256&"
import script from "./PoList.vue?vue&type=script&lang=js&"
export * from "./PoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports